<template>
  <div class="layout">
    <div class="layout__header">
      <public-header-bar></public-header-bar>
    </div>
    <div class="layout__content">
      <div class="content-sidebar"></div>
      <div id="layout__container-wrapper" class="layout__container-wrapper">
        <div class="container">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PublicHeaderBar from "@/components/layout/PublicHeaderBar.vue";

export default {
  name: "Public" ,
  components: {PublicHeaderBar}
}
</script>

<style scoped lang="scss">

</style>